import { VenueRoom as GQLItem } from '../../generated/graphql';
import * as Venue from './Venue';
import { take } from '../../util';

export type VenueRoom = {
  id: number;
  name: string;
  venue: Venue.Venue;
};

export const fromGql = (item: GQLItem): VenueRoom => ({
  ...take(item, 'id', 'name'),
  venue: Venue.fromGql(item.venue),
});
